import styled from 'styled-components';

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  padding: 16px 9px 16px 9px;

  .react-bootstrap-table {
    display: block;
    overflow: auto;
    max-height: ${window.innerHeight - 425}px;
    width: 100%;

    table {
      table-layout: auto;
    }
  }
`

export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``

export const FilterRow = styled.div.attrs({
  className: 'col-12 mt-3 px-0'
})`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0 15px 0 15px !important;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    padding-top: 0 !important;
  }
`

export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;

  @media (max-width: 1024px) {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-top: 10px;
  }
`

export const StyledPicker = styled.input`
  border-radius: 6px !important;
  font-size: 14px !important;
  height: 34px !important;
  padding: 0 12px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  background: url(${require('App/assets/images/ic_arrow_down.png')}) ${({ arrowPos }) => arrowPos ? arrowPos : '96%'} / ${({ arrowSize }) => arrowSize ? arrowSize : '10%'} no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.8)};
    box-shadow: 0px 1px 1px ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.075)} inset, 0px 1px 8px ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.6)};
    transition: .2s;
  }
`